import React from 'react';
import propTypes from 'prop-types';
import { Card, Popup } from 'semantic-ui-react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { Popconfirm } from 'antd';
import './styles/styles.scss';


const Detail = ({ onDetail }) => {
  return (
    // <div className='_buttonCard' onClick={onDetail}>
    //   <i className='fas fa-edit' />
    //   <em className='title_action animated fadeInLeft fast'>Details</em>
    // </div>
    <Col xs={4} onClick={onDetail}>
      <div style={{ textAlignLast: 'Detail', cursor: 'pointer' }}>
        <Popup content={'Detail'} position='bottom left' trigger={<i className='fas fa-edit' style={{ color: '#85C1E9' }} />} />
      </div>
    </Col>
  );
};

const Delete = ({ onDelete }) => {
  return (
    <Col xs={4}>
      <div style={{ textAlignLast: 'center', cursor: 'pointer' }}>
        <Popconfirm
          title="Are you sure you want to delete this report?"
          onConfirm={onDelete}
          okText="Yes"
          cancelText="Cancel"
        >
          <div >
            <Popup content={'Delete'} position='bottom left' trigger={<i className='fas fa-trash-alt' style={{ color: '#F1948A' }} />} />
          </div>
        </Popconfirm>
      </div>
    </Col>

  );
};

const Send = ({ onSend }) => {
  return (
    <Col xs={4} onClick={onSend}>
      <div style={{ textAlignLast: 'center', cursor: 'pointer' }}>
        <Popup content={'Send'} position='bottom left' trigger={<i className='fas fa-envelope' style={{ color: '#52BE80' }} />} />
      </div>
    </Col>

  );
};

const Standard = ({ creation, description, item }) => {
  return (
    <Col>
      <Row>
        <Col>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Creation Date:</Col>
            <Col className='valueCard' md={12} xl={12} style={{ marginLeft: '', color: "black" }}>{moment(creation).format('YYYY-MM-DD')}</Col>
          </Row>
        </Col>
      </Row>
      <Row className='_secondDetails'>
        <Col>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Description:</Col>
            <Col className='valueCard' md={12} xl={12} style={{ marginLeft: '', color: "black" }}>{description}</Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

const OnDemand = ({ creation, description, item }) => {
  return (
    <Col>
      <Row>
        <Col>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Creation Date:</Col>
            <Col className='valueCard' md={12} xl={12} style={{ marginLeft: '', color: 'black' }}>{moment(creation).format('DD-MM-YYYY')}</Col>
          </Row>
        </Col>
      </Row>
      <Row className='_secondDetails'>
        <Col>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Description:</Col>
            <Col className='valueCard' md={12} xl={12} style={{ marginLeft: '', color: 'black' }}>{description}</Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className='_ondemand' md={6}>
          <p className='titleCard'>Type:</p>
          <p className='valueCard' style={{ color: 'black' }}>{item.reportTypeLabel}</p>
        </Col>
        {
          item.reportType === 'S' ?
            <Col className='_ondemand' md={6}>
              <p className='titleCard'>Frequency:</p>
              <p className='valueCard' style={{ color: 'black' }}>{item.frequency}</p>
            </Col> : ''
        }
      </Row>
    </Col>
  );
};

const Scheduling = ({ item }) => {
  return (
    <Col>
      <Row>
        <Col md={6}>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Shared by: </Col>
            <Col className='valueCard' md={12} xl={12} style={{ color: 'black' }}>{item.SharedBy}</Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Creation Date: </Col>
            <Col className='valueCard' md={12} xl={12} style={{ color: 'black' }}>{moment(item.FechaCreacion).format('DD-MM-YYYY')}</Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row>
            <Col className='titleCard' md={12} xl={12}> Name: </Col>
            <Col className='valueCard' md={12} xl={12} style={{ color: 'black' }}>{item.Name}</Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row>
            <Col className='titleCard' md={12} xl={12}>Share date: </Col>
            <Col className='valueCard' md={12} xl={12} style={{ color: 'black' }}>{item.SharedDate}</Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className='_ondemand' md={6}>
          <p className='titleCard'>Type:</p>
          <p className='valueCard' style={{ color: 'black' }}>{item.reportTypeLabel}</p>
        </Col>
        {
          item.reportType === 'S' ?
            <Col className='_ondemand' md={6}>
              <p className='titleCard'>Frecuency:</p>
              <p className='valueCard' style={{ color: 'black' }}>{item.frequency}</p>
            </Col> : ''
        }

      </Row>
    </Col>
  );
};

/*=============================================
=            Card Components                  =
=============================================*/

const CardComponent = ({ title, creation, description, handleIn, item, type, onDelete, onSend }) => {
  return (
    <Card className='_card'>
      <Card.Content className='header_card_content'>
        <Card.Header className='title_card_content'
        // onClick={handleIn(item)}
        >
          <em className="fas fa-1x mr-2 fas fa-table" />
          {title}
        </Card.Header>
      </Card.Content>

      <Card.Content className='_content_card'>
        <Card.Description>
          {
            type === 'Standard' ?
              <Standard creation={creation} description={description} item={item} /> :
              type === 'MyReports' ?
                <OnDemand creation={creation} description={description} item={item} /> :
                type === 'SharedReports' ?
                  <Scheduling creation={creation} description={description} item={item} /> : ''
          }
        </Card.Description>
      </Card.Content>
      <Card.Content extra className='_content'>
        <div>
          {
            type === 'Standard' ?
              <Detail onDetail={handleIn(item)} /> :
              type === 'MyReports' ?
                <React.Fragment>
                  <Col xs={12} style={{ textAlignLast: 'center' }}>
                    <Row>
                      <Detail onDetail={handleIn(item)} />
                      <Delete onDelete={() => onDelete(item.id)} />
                      {
                        item.reportType === 'S' ?
                          <Send onSend={() => onSend(item.id)} /> :
                          ''
                      }
                    </Row>
                  </Col>
                </React.Fragment> :
                type === 'SharedReports' ?
                  <Detail onDetail={handleIn(item)} /> :
                  ''
          }
        </div>
      </Card.Content>
    </Card>
  );
};

CardComponent.propTypes = {
  description: propTypes.string,
  creation: propTypes.string,
  handleIn: propTypes.func,
  item: propTypes.object,
  title: propTypes.string,
  onDelete: propTypes.func,
  onSend: propTypes.func
};
CardComponent.defaultProps = {
  description: '',
  creation: '',
  handleIn: () => { },
  item: {},
  title: '',
  onDelete: () => { },
  onSend: () => { }
};

// * Card Content
export const CardsContent = ({ cards, handleIn, type = 'Standard', onDelete, onSend }) => {
  return (
    <>
      {cards.map((item, key) => {
        return (
          <CardComponent
            key={key}
            title={item.Name}
            description={item.Description}
            creation={item.CreationDate}
            handleIn={handleIn}
            item={item}
            type={type}
            onDelete={onDelete}
            onSend={onSend}
          />
        );
      })}
    </>
  );
};

// class CardComponent extends Component {
//   render() {
//     console.log("this.props", this.props);
//     let { title, creation, description, handleIn, item } = this.props;
//     return (
//       <Card className='_card'>

//         <Card.Content className='header_card_content'>
//           <Card.Header className='title_card_content'> <em className="fas fa-1x mr-2 fas fa-table" />{title}</Card.Header>
//         </Card.Content>

//         <Card.Content className='_content_card'>
//           <Card.Description>
//             <Col>
//               <Row>
//                 <Col>
//                   <Row>
//                     <Col className='titleCard' md={12} xl={12}>Creation Date:</Col>
//                     <Col className='valueCard' md={12} xl={12} style={{ marginLeft: '', color: "black" }}>{moment(creation).format('YYYY-MM-DD')}</Col>
//                   </Row>
//                 </Col>
//               </Row>
//               <Row className='_secondDetails'>
//                 <Col>
//                   <Row>
//                     <Col className='titleCard' md={12} xl={12}>Description:</Col>
//                     <Col className='valueCard' md={12} xl={12} style={{ marginLeft: '', color: "black" }}>{description}</Col>
//                   </Row>
//                 </Col>
//               </Row>

//             </Col>

//           </Card.Description>
//         </Card.Content>

//         <Card.Content extra className='_content'>
//           <Col>
//             <Row>
//               <Col md={6} xl={6} />
//               <Col md={6} xl={6}> <div className='_buttonCard' onClick={handleIn(item)}><Icon name='external alternate' className='icon_query' /> <em className='title_action animated fadeInLeft fast'>Details</em></div></Col>
//             </Row>
//           </Col>
//         </Card.Content>
//       </Card>
//     );
//   }
// }

// export const CardsContent = ({ cards, handleIn }) => {
//   return (
//     <>
//       {cards.map((item, key) => {
//         return (
//           <CardComponent
//             key={key}
//             title={item.Name}
//             description={item.Description}
//             creation={item.CreationDate}
//             handleIn={handleIn}
//             item={item}
//           />
//         );
//       })}
//     </>
//   );
// };
